var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_vm._m(0),_vm._m(1),_c('transition',{attrs:{"type":"transition","name":"fadee","mode":"out-in","appear":""}},[_c('keep-alive',[_c('router-view')],1)],1),_c('br'),(
  _vm.$route.path == "/settings" ||
  _vm.$route.path == "/calender" ||
  _vm.$route.path == "/quran" ||
  _vm.$route.path == "/adkar" ||
  _vm.$route.path == "/" ||
  _vm.$route.path == "/settings"
  )?_c('footer-cmp'):_vm._e(),_vm._m(2)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loadingAnimaiton",attrs:{"id":"loading-animaiton"}},[_c('br'),_c('br'),_c('br'),_c('img',{attrs:{"src":"logo.svg","alt":"logo"}}),_c('br'),_c('br'),_c('div',[_c('div',{staticClass:"spinner"},[_c('span',{staticClass:"spinner-1"}),_c('span',{staticClass:"spinner-2"})]),_c('p',{staticClass:"loadingText"},[_vm._v(" الرجاْ الإنتظار قليلا ")])])])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"online"},[_c('p',[_vm._v("لا يوجد اتصال بالانترنت")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"myBackground"},[_c('div'),_c('div'),_c('div')])
}]

export { render, staticRenderFns }